import * as React from 'react';
import {NavLink} from 'react-router-dom';

import ImageLazy from '@common/react/components/UI/ImageLazy/ImageLazy';

const year = new Date().getFullYear();

const Footer: React.FC<{}> = () => {
	return <footer className="site-footer">
		<div className="container row-content">
			<div className="site-footer__copyright">
				© {year} NorthernTuna, all rights reserved
			</div>
			<div className="text-center site-footer__links">
				<NavLink className="ml10 mr10 site-footer__link" to="/doctors">Doctors</NavLink>
				<NavLink className="ml10 mr10 site-footer__link" to="/specials">Specials</NavLink>
				<NavLink className="ml10 mr10 site-footer__link" to="/procedures?count=200">Procedures</NavLink>
				<NavLink className="ml10 mr10 site-footer__link" to="/specialties?count=200">Specialties</NavLink>
				<NavLink className="ml10 site-footer__link" to="/privacy-policy">Privacy&nbsp;Policy</NavLink>
				<a className="ml10 mr10 site-footer__link" href="https://portal.northerntuna.com/" target="_blank">Providers&nbsp;Portal</a>
			</div>
			<div className="nt-logo">
				<ImageLazy height={35} src="/amp-assets/images/nt-logo.png" alt="Northern Tuna Logo"/>
			</div>
		</div>
	</footer>;
};

export default Footer;